import {
    Component,
    Input,
    Output,
    ElementRef,
    OnInit,
    OnChanges,
    AfterViewInit,
    SimpleChanges,
    EventEmitter
} from '@angular/core';

import {ProductGroup} from "../model/product.group";
import {EventsService} from "../services/events.service";
import {Logger} from "../utils/logger";
import {SubProductTabSelectedEvent} from "../model/subproduct";


@Component({
    selector: 'subproduct-tab',
    templateUrl: "./subproduct_tab.component.html"
})

export class SubProductTabComponent implements OnInit, AfterViewInit, OnChanges {
    @Input("group")
    public productGroup;

    @Input()
    public action;

    @Input()
    public tabName;

    @Input()
    public tabActive: boolean;

    @Output('onSubProductTabSelected')
    public subProductTabSelected: EventEmitter<SubProductTabSelectedEvent>;

    constructor(public el: ElementRef, public eventBus: EventsService, public logger: Logger) {
        this.subProductTabSelected = new EventEmitter<SubProductTabSelectedEvent>();
    }

    ngOnInit(): any {

    }

    ngAfterViewInit(): any {
        if (this.productGroup.alter) {
            var tabCaption = this.el.nativeElement.querySelector('.tab');

            tabCaption.innerHTML = this.productGroup.AlternativesTabName;
        }
    }

    ngOnChanges(changes: any): any {
    }

    onSubProductTabSelected(event: Event, group: ProductGroup, action: string) {
        if ((event.target as HTMLElement).className.toLowerCase() === 'tab') {
            // this.showProductSpinner();
            this.subProductTabSelected.emit({productGroup: group, action: action});
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/sidebar/subproduct_tab.component.ts